import React, { useEffect, useState, useMemo } from 'react'
import {
  IServiceItem,
  IServiceTag,
} from '../../../../../network/models/OrderTypes'
import styles from './index.module.scss'
import scrollLock from '../../../../../utils/scroll-lock'
import request from '../../../../../network/request'
import { message } from 'antd'

interface IProps {
  orderId?: any
  originServiceItems?: IServiceItem[]
  onConfirm: () => void
  onCancel: () => void
}

interface IClassifyServiceItem {
  tag: IServiceTag
  serviceItems: IServiceItem[]
}

export default function OperateModal({
  orderId,
  originServiceItems = [],
  onConfirm,
  onCancel,
}: IProps) {
  const [chosenList, setChosenList] =
    useState<IServiceItem[]>(originServiceItems)
  const [serviceItemList, setServiceItemList] = useState<IServiceItem[]>([])
  const [tagList, setTagList] = useState<IServiceTag[]>([])
  const [isLoading, setIsLoading] = useState<boolean>(true)

  useEffect(() => {
    scrollLock.enable()
    getInitialData()
    return () => {
      message.destroy()
      scrollLock.disable()
    }
  }, [])

  const getInitialData = async () => {
    await fetchData()
    setIsLoading(false)
  }

  const fetchData = async () => {
    return Promise.all([getServiceItemList(), getServiceTagList()])
  }

  const classifyList = useMemo(() => {
    if (serviceItemList?.length > 0 && tagList?.length > 0) {
      let res: IClassifyServiceItem[] = []
      tagList.map((tag) => {
        const list: IServiceItem[] = serviceItemList.filter((item) =>
          item.tags?.includes(tag.code)
        )
        if (list?.length > 0) {
          res.push({
            tag,
            serviceItems: list,
          })
        }
      })
      return res
    } else {
      return []
    }
  }, [serviceItemList, tagList])

  const getServiceItemList = async () => {
    try {
      let res: any = await request.get(`/dragon/service/order/item/list`)
      setServiceItemList(res)
    } catch (err: any) {
      message.error(err?.message || '获取服务项目列表失败')
    }
  }

  const getServiceTagList = async () => {
    try {
      let res: any = await request.get(`/dragon/service/item/tags`)
      setTagList(res)
    } catch (err: any) {
      message.error(err?.message || '获取服务标签列表失败')
    }
  }

  const handleFinishSelect = async () => {
    const loaded = message.loading('加载中...', 0)
    try {
      await request.post('/dragon/service/order/item/save', {
        serviceOrderId: orderId,
        items: [...chosenList],
      })
      onConfirm()
    } catch (err: any) {
      message.error(err?.message || '更新服务项目失败')
    } finally {
      loaded()
    }
  }

  const handleServiceItem = (item: IServiceItem) => {
    const index = chosenList.findIndex(
      (itemFind) => `${itemFind.itemId}` === `${item.itemId}`
    )
    if (index < 0) {
      const tmp = [...chosenList, item]
      setChosenList(tmp)
    } else {
      const tmp = [...chosenList]
      tmp.splice(index, 1)
      setChosenList(tmp)
    }
  }

  return (
    <div
      className={styles.drawerWrap}
      onClick={(e) => {
        e.stopPropagation()
      }}
    >
      <div className={styles.drawerContainer}>
        <div className={styles.titleContainer}>
          <div className={styles.close} onClick={onCancel}>
            取消
          </div>
          <div className={styles.titleText}>
            <div className={`${styles.textStyle} ${styles.item}`}>
              添加服务项目
            </div>
            <div className={`${styles.textStyle} ${styles.selected}`}>
              {`已选择 ${chosenList.length} 项服务`}
            </div>
          </div>
          <div className={styles.finishSelect} onClick={handleFinishSelect}>
            完成
          </div>
        </div>
        <div className={styles.serviceWrap}>
          {isLoading ? (
            <p className={styles.loadingTip}>服务项目加载中...</p>
          ) : classifyList?.length === 0 ? (
            <p className={styles.loadingTip}>服务项目为空</p>
          ) : (
            ''
          )}
          {classifyList.map((classifyItem, classifyIndex) => {
            return (
              <div key={classifyIndex}>
                <h3 className={styles.tagTitle}>{classifyItem?.tag?.name}</h3>
                <div className={styles.serviceItemContainer}>
                  {classifyItem?.serviceItems?.map((serviceItem) => {
                    return (
                      <div
                        key={serviceItem.itemId}
                        className={[
                          styles.serviceItem,
                          chosenList.find(
                            (cItem) =>
                              `${cItem.itemId}` === `${serviceItem.itemId}`
                          )
                            ? styles.chosen
                            : '',
                        ].join(' ')}
                        onClick={() => handleServiceItem(serviceItem)}
                      >
                        {serviceItem.abbreviation}
                      </div>
                    )
                  })}
                </div>
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}
